import Vue from "vue";
import axios from "axios";
import mixins from "./mixins";

Vue.prototype.$http = axios.create({
    baseURL: Vue.prototype.$api_url,
    headers: {
        Authorization: "Bearer " + Vue.prototype.$token.value
    },
    transformRequest: (data, heads) => {
        if (navigator && navigator.onLine !== undefined) {
            if (navigator.onLine) {
                Vue.prototype.$load(1);
            } else {
                Vue.prototype.$toastr.removeByType("error");
                Vue.prototype.$toastr.e("Connection Error");
            }
        }

        let fd = data instanceof FormData;
        heads["Content-Type"] = fd ? "multipart/form-data" : "application/json";
        return fd ? data : JSON.stringify(data);
    },
    transformResponse: data => {
        Vue.prototype.$load();
        return JSON.parse(data);
    }
});

Vue.prototype.$silentHttp = axios.create({
    baseURL: Vue.prototype.$api_url,
    headers: {
        Authorization: "Bearer " + Vue.prototype.$token.value
    },
    transformRequest: (data, heads) => {
        let fd = data instanceof FormData;
        heads["Content-Type"] = fd ? "multipart/form-data" : "application/json";
        return fd ? data : JSON.stringify(data);
    },
    transformResponse: data => {
        if (data) {
            return JSON.parse(data);
        }

        return data;
    }
});

Vue.prototype.$http.interceptors.response.use(
    response => {
        if (!!response.data.message && response.data.message) {
            if (response.data.status) {
                Vue.prototype.$toastr.s(response.data.message);
            } else {
                let __session_not_found = 0;
                if (response.data.message === "Session not found") {
                    __session_not_found = Vue.prototype.$getLocalStorage(
                        "__session_not_found"
                    )
                        ? Vue.prototype.$getLocalStorage("__session_not_found")
                        : 0;

                    __session_not_found = parseInt(__session_not_found) + 1;

                    Vue.prototype.$setLocalStorage(
                        "__session_not_found",
                        __session_not_found
                    );
                }

                let message = response.data.message.toLowerCase();

                if (message === "bad credentials") {
                    Vue.prototype.$toastr.e(
                        response.data.message + ". Please re-authorize."
                    );
                    mixins.helpers.methods.logOutActions();
                } else if (__session_not_found <= 1) {
                    Vue.prototype.$toastr.e(response.data.message);
                }
            }
        }

        if (!!response.data.error && response.data.error)
            Vue.prototype.$toastr.e(response.data.error);
        return response.data;
    },
    error => {
        if (error.response && error.response.data.message)
            Vue.prototype.$toastr.e(error.response.data.message);
        throw new Error("Response");
    }
);
